export default __webpack_public_path__ + "static/media/picture1.1ddefaf7.png";